import React from "react";
import styles from "../../styles/CreateToken.module.css";
import createGroup from "../../images/create_group.png";
import usd from "../../images/usd.svg";
import gallery from "../../images/gallery.svg";
import calculator from "../../images/calculator.svg";
import barcode from "../../images/barcode.svg";
import EnvironmentVariable from "./EnvironmentVariables/EnvironmentVariables";
import { deployContract } from "viem";
import { useWalletClient } from 'wagmi'
import { useAccount } from "wagmi";


const CreateToken = () => {
  const { data: walletClient, isError, isLoading } = useWalletClient()
  const { account } = useAccount()
  const [tokenName, setTokenName] = React.useState("");
  const [tokenSymbol, setTokenSymbol] = React.useState("");
  const [tokenSupply, setTokenSupply] = React.useState("");
  const [tokenDecimal, setTokenDecimal] = React.useState("18");
  const [wallets, setWallets] = React.useState([]);
  const [amounts, setAmounts] = React.useState([]);


  function wallets_amount_parser(addresses, amounts) {
    let wallets = [];
    let amounts_ = [];
    for (let i = 0; i < addresses.length; i++) {
      if (addresses[i] !== "") {
        wallets.push(addresses[i]);
        amounts_.push(amounts[i] * 10 ** Number(tokenDecimal));
      }
    }
    console.log("wallets", wallets);
    console.log("amounts", amounts_);
    setWallets(wallets);
    setAmounts(amounts_);
  }


  let byte_code = "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"
  let abi = [
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "_name",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "_symbol",
          "type": "string"
        },
        {
          "internalType": "uint8",
          "name": "_decimals",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "_totalSupply",
          "type": "uint256"
        },
        {
          "internalType": "address[]",
          "name": "wallets",
          "type": "address[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "success",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "burn",
      "outputs": [
        {
          "internalType": "bool",
          "name": "success",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "success",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "success",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ]

  async function deployContract() {
    const hash = await walletClient.deployContract({
      abi,
      account,
      args: [tokenName, tokenSymbol, tokenDecimal, tokenSupply * 10 ** Number(tokenDecimal), wallets, amounts],
      bytecode: byte_code,
    });
    console.log(hash);

  }

  return (
    <section className={styles.wrapper} style={{ marginTop: "90px" }}>
      <div className={styles.container}>
        <div className={styles.img}>
          <img src={createGroup} alt="" />
        </div>
        <div className={styles.token_form}>
          <div className={styles.heading}>
            <h3>Create Your own Token</h3>
            <p>{`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do `}</p>
          </div>
          <div className={styles.input_list}>
            <div>
              <div className={styles.form_detail}>
                <h5>Token name</h5>
                <h6>eg: Bitcoin</h6>
              </div>
              <div className={styles.input}>
                <img src={usd} alt="" />
                <span className={styles.vertical_line}></span>
                <input
                  type="text"
                  name="email"
                  id="email"
                  placeholder="Enter your token name"
                  onChange={(e) => setTokenName(e.target.value)}
                  value={tokenName}
                />
              </div>
            </div>
            <div>
              <div className={styles.form_detail}>
                <h5>Token symbol</h5>
                <h6>eg:BTC</h6>
              </div>
              <div className={styles.input}>
                <img src={gallery} alt="" />
                <span className={styles.vertical_line}></span>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter your token symbol"
                  onChange={(e) => setTokenSymbol(e.target.value)}
                  value={tokenSymbol}
                />
              </div>
            </div>
            <div>
              <div className={styles.form_detail}>
                <h5>Token supply</h5>
                <h6>{`eg:100 { Do not us decimal}`}</h6>
              </div>
              <div className={styles.input}>
                <img src={calculator} alt="" />
                <span className={styles.vertical_line}></span>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter your token supply"
                  onChange={(e) => {
                    let supply = e.target.value;
                    setTokenSupply(supply);
                  }}
                  value={tokenSupply}
                />
              </div>
            </div>
            <div>
              <div className={styles.form_detail}>
                <h5>Decimal</h5>
                <h6>{`(“18 Recommended”)`}</h6>
              </div>
              <div className={styles.input}>
                <img src={barcode} alt="" />
                <span className={styles.vertical_line}></span>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter your token decimal"
                  onChange={(e) => setTokenDecimal(e.target.value)}
                  value={tokenDecimal}
                />
              </div>
            </div>
          </div>
          <EnvironmentVariable wallets_amount_parser={wallets_amount_parser} />
          <h5 className={styles.fee}>
            Fee ≈{" "}
            <span
              style={{ color: "#E9F2FF", fontWeight: 500 }}
            >{`(0.3% Total Supply) + 24 BNB`}</span>
          </h5>
          <button
            onClick={() => {
              deployContract()
            }}
          >Mint a token</button>
        </div>
      </div>
    </section>
  );
};

export default CreateToken;
